import ReactApexChart from 'react-apexcharts';
import { getXAxisLabel } from 'utils/services';

function formatDateLabel(dateStr, xAxisTitle) {
  // For Months (YYYY-MM-DD)
  if (xAxisTitle === 'month' && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [year, month] = dateStr?.split('-');
    const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1);
    return date?.toLocaleString('en-US', { month: 'short', year: '2-digit' }); // e.g., "Sep"
  }

  // For Days (YYYY-MM-DD)
  if (xAxisTitle === 'day' && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [year, month, day] = dateStr?.split('-');
    const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
    return date?.getDate()?.toString(); // just numeric day
  }

  // For Weeks (custom handling: "YYYY-MM-DD"
  if (xAxisTitle === 'week' && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [year, month, day] = dateStr?.split('-');
    const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));

    // Get the end of the 7-day range
    const endDate = new Date(date);
    endDate?.setDate(date?.getDate() + 6);

    const formatDay = (d) => String(d)?.padStart(2, '0');
    const startDay = formatDay(date?.getDate());
    const endDay = formatDay(endDate?.getDate());

    const monthName = date?.toLocaleString('en-US', { month: 'short' }); // e.g. "Dec"
    const shortYear = date?.getFullYear()?.toString()?.slice(-2); // "25"

    return `${startDay}-${endDay} (${monthName}-${shortYear})`;
  }
}

const PaymentLineChart = ({ data, dateRange }) => {
  const xAxisTitle = getXAxisLabel(dateRange);
  const state = {
    series: [
      {
        name: 'Acceptance Rate',
        data: data?.map?.((el) => el?.acceptanceRate),
      },
    ],
    options: {
      chart: {
        height: 350,
        type: 'line',
        dropShadow: {
          enabled: true,
          color: '#8CCC43',
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.5,
        },
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      colors: ['#8CCC43', '#545454'],
      dataLabels: {
        enabled: true,
        // Nudge the labels up a bit so they don't touch the markers
        offsetY: -6,
        style: {
          fontSize: '10px',
          fontWeight: 400,
          colors: ['#000000'],
        },
        background: {
          enabled: false, // Ensures no background color behind the label text
        },
      },
      stroke: {
        curve: 'smooth',
        width: 3, // Made the line slightly thicker
      },
      grid: {
        show: true,
        xaxis: {
          lines: {
            show: true,
          },
        },
        yaxis: {
          lines: {
            show: true,
          },
        },
        row: {
          colors: undefined,
          opacity: 0.1,
        },
        column: {
          colors: undefined,
          opacity: 0.1,
        },
        strokeDashArray: 3,
      },
      markers: {
        size: 6,
        // The marker's border color should match the line color
        strokeColors: '#ffffff',
        // The width of the marker's border
        strokeWidth: 2,
        // The fill color of the marker
        colors: ['#8CCC43'],
        hover: {
          size: 7,
        },
      },
      xaxis: {
        categories: data?.map?.((el) => formatDateLabel(el?.period, xAxisTitle?.value)),
        title: {
          text: xAxisTitle?.label,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: 'Acceptance Rate (%)',
        },
        min: 0,
        max: 100,
        decimalsInFloat: false,
        labels: {
          offsetX: -5,
        },
      },
      legend: {
        position: 'bottom',
        horizontalAlign: 'center',
        itemMargin: {
          horizontal: 20,
          vertical: 8,
        },
      },
    },
  };

  return (
    <div>
      <div id='chart'>
        <ReactApexChart options={state?.options} series={state?.series} type='line' height={350} />
      </div>
      <div id='html-dist'></div>
    </div>
  );
};

export default PaymentLineChart;
